import type { ReactNode } from 'react';
import { GovIcon, GovTag } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { PageCode } from '@gov-nx/module/page';
import { Button, DocumentDownloadItem } from '@gov-nx/ui/web';

type Props = {
	children: ReactNode;
	isFile?: boolean;
	fileSize?: number;
	name?: string;
	onRemoveClick?: () => void;
};

export const FormListItem = ({
	onRemoveClick,
	isFile = false,
	fileSize = 0,
	name,
	children,
}: Props) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const button = (
		<Button
			color="primary"
			type="base"
			size="s"
			onClick={onRemoveClick}
			className="w-[38px]! ml-auto!"
			aria-label={tn('nova-zprava.wcag.odebrat')}
			iconStart={
				<GovIcon
					name="x-lg"
					type="components"
				/>
			}
		/>
	);

	return (
		<li className="w-full [ sm:w-auto ]">
			{isFile ? (
				<span className="document-download-static">
					<DocumentDownloadItem
						name={name}
						size={fileSize}>
						{button}
					</DocumentDownloadItem>
				</span>
			) : (
				<GovTag
					color="neutral"
					size="s"
					type="subtle"
					className="pr-0! bg-(--background-block-primary)!">
					{children}
					{button}
				</GovTag>
			)}
		</li>
	);
};
